import { SiteLogoQuery, SiteSettingId, SiteSettingResponse } from '@business/entities/site_setting';
import { Endpoint } from '../endpoint';
import { CommonService } from '@business/services';
import { CompanyId } from '@business/entities/companies';

export function fetchSiteSettingCollections() {
  return Endpoint.get<SiteSettingResponse[]>(`@makh/site-setting`);
}

export function fetchSiteSetting(key: string) {
  return Endpoint.get<SiteSettingResponse>(`@makh/site-setting/setting/${key}`);
}

export function updateSiteSetting(id: SiteSettingId, siteSetting: Partial<SiteSettingResponse>) {
  return Endpoint.patch<SiteSettingResponse>(`@makh/site-setting/${id}`, { data: { ...siteSetting } });
}

export function updateSiteLogos(id: CompanyId, siteSetting: Partial<SiteLogoQuery>) {
  const formData = CommonService.toFormData(siteSetting);

  return Endpoint.post<SiteSettingResponse[]>(`@makh/site-setting/update-logos/${id}`, { formData, hasFiles: true });
}
